import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEnums } from "../Redux/Actions/enumsActions";
import MapsAddress from "./mapsAddress";

const AroundThisProject = ({
  aroundThisList,
  setAroundThisList,
  onChange,
  existingAround,
}) => {
  const dispatch = useDispatch();

  const [currentAroundThis, setCurrentAroundThis] = useState({
    icon: "",
    name: "",
    type: "",
    location: { type: "Point", coordinates: [null, null], address: "" },
    distance: null,
  });
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    dispatch(getEnums());
  }, [dispatch]);

  useEffect(() => {
    if (
      !isInitialized &&
      Array.isArray(existingAround) &&
      existingAround.length > 0 &&
      existingAround.every((item) => item.name && item.type)
    ) {
      setAroundThisList(existingAround);
      setIsInitialized(true);
    }
  }, [existingAround]);

  useEffect(() => {
    if (onChange) {
      onChange(aroundThisList);
    }
  }, [aroundThisList, onChange]);

  const { enumsData } = useSelector((state) => state.enumsData || {});

  const handleTypeChange = (event) => {
    const value = event.target.value;

    const selectedEnum = enumsData?.data?.aroundThisProject?.find(
      (item) => item.name === value
    );

    setCurrentAroundThis((prevData) => ({
      ...prevData,
      type: value,
      icon: selectedEnum?.icon || "",
    }));
  };

  const handleRemove = (indexToRemove) => {
    setAroundThisList((prev) =>
      prev.filter((_, index) => index !== indexToRemove)
    );
  };

  const handleLocationChange = ({ lat, lng, address }) => {
    if (lat == null || lng == null) {
      console.warn("Invalid lat/lng from MapsAddress:", { lat, lng });
      return;
    }

    setCurrentAroundThis((prevData) => ({
      ...prevData,
      location: {
        type: "Point",
        coordinates: [lng, lat],
        address, // Keep address in location only
      },
    }));
  };

  const handleAdd = () => {
    if (!currentAroundThis.type || !currentAroundThis.name) {
      alert("Please select a type and enter a valid address.");
      return;
    }

    setAroundThisList((prevData) => [...prevData, currentAroundThis]);

    setCurrentAroundThis({
      icon: "",
      name: "",
      type: "",
      location: { type: "Point", coordinates: [null, null], address: "" },
      distance: null,
    });
  };

  return (
    <div>
      <div className="width-90">
        <span style={{ fontSize: "14px" }}>
          Around this Project <span style={{ color: "red" }}>*</span>
        </span>
        <div className="flex-end gap-10">
          <select
            className="input-class"
            label="Around This Project"
            value={currentAroundThis.type}
            onChange={handleTypeChange}
            placeholder="Select an Option"
          >
            <option value="" disabled hidden>
              Select An Option
            </option>
            {Array.isArray(enumsData?.data?.aroundThisProject)
              ? enumsData.data.aroundThisProject.map((enums) => (
                  <div>
                    <img src={enums.icon} alt="" />
                    <option value={enums.name}>
                      {enums?.name?.charAt(0).toUpperCase() +
                        enums?.name?.slice(1)}
                    </option>
                  </div>
                ))
              : []}
          </select>
          <button className="button-class-white" onClick={handleAdd}>
            Add
          </button>
        </div>
        {currentAroundThis.type && (
          <div className="margin-h-10">
            <input
              className="input-class-map"
              style={{ borderRadius: "5px 5px 0px 0px" }}
              placeholder="Enter Name"
              value={currentAroundThis.name}
              onChange={(event) =>
                setCurrentAroundThis((prevData) => ({
                  ...prevData,
                  name: event.target.value,
                }))
              }
            />
            <MapsAddress
              value={{ address: currentAroundThis.location.address }}
              noLabel={false}
              onChange={handleLocationChange}
            />
          </div>
        )}
      </div>

      {aroundThisList?.length > 0 && (
        <div className="margin-0">
          <ul className="flex-container gap-10 flex-wrap padding-0">
            {aroundThisList.map((item, index) => (
              <li
                key={index}
                style={{ listStyle: "none" }}
                className="padding-5 border-1-grey border-15"
              >
                <span>{item.name}</span>
                <span
                  onClick={() => handleRemove(index)}
                  style={{ color: "red", cursor: "pointer" }}
                >
                  ❌
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default AroundThisProject;
